<template>
  <div>
    <div class="progress-bar">
      <el-progress
        :stroke-width="10"
        :percentage="localPercentage"
        :show-text="false"
        :status="status"
      />
    </div>
  </div>
</template>

<script>
// easeOutQuad 缓动函数
function easeOutQuad(t) {
  return t * (2 - t);
}

export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    done: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'success',
    },
  },
  data() {
    return {
      localPercentage: 0,
    };
  },
  methods: {
    simulateProgress(updateInterval = 100) {
      const that = this;
      return new Promise((resolve) => {
        let progress = 0;
        const startTime = Date.now();

        function update() {
          if (that.done) {
            progress = 100;
          } else {
            const currentTime = Date.now();
            const elapsedTime = currentTime - startTime;

            // 使用对数函数来减缓增长速度
            progress = Math.min(99, 20 * Math.log(1 + elapsedTime / 1000));
          }

          const easedProgress = easeOutQuad(progress / 100) * 100;

          // 输出当前进度（可以根据需要替换为更新 UI 的代码）
          that.localPercentage = Number(easedProgress.toFixed(2));

          if (progress < 100) {
            setTimeout(update, updateInterval);
          } else {
            resolve();
          }
        }

        update();
      });
    },
  },
  mounted() {
    if (this.status === 'error') {
      this.localPercentage = 100;
      return;
    }

    this.simulateProgress(300);
  },
};
</script>

<style lang="scss" scoped>
</style>